import { addSideEffects, initAction } from '@poa/state';
import { captureException } from '../../utils/errors';
import { invalidateSession, logIn, logInSuccess, restoreSession } from './auth.actions';
import { GRANTED_HOSTS, HOST_TO_URL, LOGGED_IN_ROUTE, STORAGE_KEY } from './auth.constants';

addSideEffects(logIn, async (payload, { actions, env, router }) => {
  try {
    const response = await env.api.auth.authenticate(payload.username, payload.password);

    await actions.authActions.logInSuccess({
      accessLevel: response.data.group,
      accessHosts: response.data.hosts
    });
  } catch (e) {
    console.error(e);
    actions.authActions.logInFailed();
    throw e;
  }
});

addSideEffects(
  logInSuccess,
  async ({ accessLevel, accessHosts }, { router, env, actions, store }) => {
    // save access level to db
    await env.storage.setItem(STORAGE_KEY, { accessLevel, accessHosts });
    // update permissions according to location and access level
    await actions.authActions.updatePermissions(window.location.hostname, accessLevel, accessHosts);
    // restore access level and add
    await actions.authActions.restoreSession(accessLevel, accessHosts);

    // redirect to initial route
    router.replace(LOGGED_IN_ROUTE);
  }
);

let httpResponseInterceptorRef;

addSideEffects(restoreSession, async ({ accessLevel, accessHosts }, { env, actions, store }) => {
  // logout on 401 call
  httpResponseInterceptorRef = env.http.interceptors.response.use(
    r => r,
    error => {
      if (error.response && error.response.status === 401) {
        actions.authActions.invalidateSession();
      }

      if (error.response && error.response.status === 403) {
        env.alert(
          'Error',
          error.response.data.error_message ||
            'У вас недостаточно  прав для просмотра этой страницы.',
          'error'
        );
      }

      return Promise.reject(error);
    }
  );

  if (!store.auth.canAccessCurrentHost) {
    const redirectUrl = HOST_TO_URL[accessHosts[0]];
    const redirectParams = `?accessLevel=${accessLevel}&accessHosts=${accessHosts.join(',')}`;

    await env.storage.clear();

    if (redirectUrl) {
      window.location.replace(redirectUrl + redirectParams);
    } else {
      window.location.replace(HOST_TO_URL[GRANTED_HOSTS.nc] + redirectParams);
    }
  }
});

addSideEffects(invalidateSession, async (_, { env }) => {
  try {
    await env.api.auth.logout();
  } catch (e) {
    captureException(e);
  }
  await env.storage.clear();
  env.http.interceptors.response.eject(httpResponseInterceptorRef);

  window.location.reload();
});

addSideEffects(initAction, async (_, { actions, env, router }) => {
  // grab existent access level and hosts
  const authData = await env.storage.getItem(STORAGE_KEY);
  const urlData = new URL(window.location);

  // case: we already logged in (some data in DB)
  if (authData && authData.accessLevel && authData.accessHosts) {
    await actions.authActions.updatePermissions(
      window.location.hostname,
      authData.accessLevel,
      authData.accessHosts
    );
    await actions.authActions.restoreSession(authData.accessLevel, authData.accessHosts);

    return;
  }

  if (urlData.searchParams.has('accessLevel') && urlData.searchParams.has('accessHosts')) {
    const accessLevel = urlData.searchParams.get('accessLevel');
    const accessHosts = urlData.searchParams.get('accessHosts');

    await actions.authActions.updatePermissions(window.location.hostname, accessLevel, accessHosts);
    await actions.authActions.restoreSession(
      accessLevel,
      accessHosts.includes(',') ? accessHosts.split(',') : [accessHosts]
    );

    return;
  }
});
